import React from 'react';
import {
  FaGraduationCap,
  FaMedal,
  FaAward,
  FaGlobeAmericas,
  FaTrophy,
} from 'react-icons/fa';
import { FadeIn } from './animations/MotionPrimitives';
import './styles/Awards.css';

const AWARDS = [
  {
    icon: <FaGraduationCap aria-hidden="true" />,
    tone: 'gold',
    title: 'Cum Laude',
    detail: 'B.S. Computer Science, California State University Sacramento.',
  },
  {
    icon: <FaMedal aria-hidden="true" />,
    tone: 'blue',
    title: "Dean's Honor List",
    detail: 'Recognized for sustained academic performance across multiple semesters.',
  },
  {
    icon: <FaAward aria-hidden="true" />,
    tone: 'blush',
    title: 'Graduate Academic Excellence Scholar',
    detail: 'Merit award from Illinois Institute of Technology.',
  },
  {
    icon: <FaGlobeAmericas aria-hidden="true" />,
    tone: 'sage',
    title: 'International Student Fee Waiver',
    detail: 'Awarded for academic merit and contribution to the campus community.',
  },
  {
    icon: <FaTrophy aria-hidden="true" />,
    tone: 'lav',
    title: 'Student Employee of the Year Nominee',
    detail: 'Nominated in both 2023 and 2024 for dependable, high-priority work.',
  },
];

function Awards() {
  return (
    <section className="section awards" id="awards">
      <div className="section-inner">
        <FadeIn className="chapter-head awards-head">
          <span className="chapter-mark">06</span>
          <h2 className="chapter-title">Awards &amp; Recognition</h2>
        </FadeIn>

        <div className="awards-grid">
          {AWARDS.map((award, index) => (
            <FadeIn
              as="article"
              className={`award-card award-card--${award.tone}`}
              key={award.title}
              delay={(index % 3) * 0.05}
            >
              <span className="award-icon" aria-hidden="true">
                {award.icon}
              </span>
              <h3 className="award-title">{award.title}</h3>
              <p className="award-detail">{award.detail}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Awards;
